export default __webpack_public_path__ + "static/media/line.f7047d1f.svg";